import { getIrrigationProperties } from 'App/irrigation-scheduler/utils/store/selectors/getIrrigationProperties'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'
import { checkAuthorization } from 'utils/checkAuthorization'

export const getPermittedIrrigationReportProperties = (fass: TFieldAssetStoreState) =>
  getIrrigationProperties(fass).filter((p) =>
    checkAuthorization({ permission: 'CREATE_REPORT_ON_DEMAND_IRRIGATION_ACTIVITY', entity: p.propertyId }),
  )
